module.exports = __webpack_public_path__ + "static/media/thumbs-down.4758b982.svg";